webpackJsonp([2],{3:function(e,n,o){e.exports=o("ikef")},ikef:function(e,n){var o=document.querySelector('main div[class^="bloom-"]');o&&window.addEventListener("scroll",function(){o.style.top=40-1.25*window.pageYOffset+"px"})}},[3]);


// WEBPACK FOOTER //
// /js/templates/default.js